/**
Author - Venkatesh Pullaganti
Git - https://github.com/venkatesh1146
**/

import AddressProof from "./AddressProof.container";

export default AddressProof;
